/*! @azure/msal-common v15.1.1 2025-02-05 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.1.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
